import React from "react";

import Link from "../../link";
import { IIcon, IMedia } from "../../../interfaces";

class Icon extends React.Component<IIcon> {
  render() {
    const {
      name,
      image: {
        data: { attributes: image }
      },
      url: link,
      size
    } = this.props;
    if (image == null) return null;
    const { className, alternativeText, url, dataSrc }: IMedia = image;

    const IconWrapper = (
      <>
        <div className={`icon-image ${!name && "no-label"}`}>
          <img
            data-src={dataSrc ? url : null}
            src={!dataSrc ? url : null}
            alt={alternativeText}
            className={className}
          />
        </div>
        {name && <div className="icon-label">{name}</div>}
      </>
    );

    return link ? (
      <div
        className="icon-wrapper"
        style={{
          flexBasis: size
        }}
      >
        <Link to={link}>{IconWrapper}</Link>
      </div>
    ) : (
      <div className="icon-wrapper" style={{ flexBasis: size }}>
        {IconWrapper}
      </div>
    );
  }
}

export default Icon;
